module.exports = __webpack_public_path__ + "static/media/confirmed.36d58126.svg";